import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconChangeRole = styled.img.attrs({
  src: "/assets/images/icon-change-role.png",
  alt: "Change Role",
  title: "Change Role"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconChangeRole.displayName = "ChangeRole";

export default IconChangeRole;
